import { API_SERVICE } from "./root";
//  导入pb文件
//  authorize的proto
import { AuthServiceClient } from "@/pbjs/external/auth/auth_grpc_web_pb";
//  命名请求对象
let authorClient: any = new AuthServiceClient(API_SERVICE, null, null);

export { authorClient };
